import { Component, OnDestroy, OnInit } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { Config } from '@ionic/core';
import { TranslateService } from '@ngx-translate/core';
import { Options } from 'qr-code-styling';
import { FunctionService } from 'src/app/services/general/function.service';
import { PopupService } from 'src/app/services/general/popup.service';
import { GuestExportService } from 'src/app/services/guest/guest-export.service';
import { VisitorLogoService } from 'src/app/services/visitor/visitor-logo.service';

@Component({
  selector: 'app-export-qrcode',
  templateUrl: './export-qrcode.component.html',
  styleUrls: ['./export-qrcode.component.scss'],
})
export class ExportQrcodeComponent  implements OnInit, OnDestroy {

  showTxt: boolean;
  topTxt: string;
  bottomTxt: string;
  config: Options;
  logoWidth: number;

  logoUrl: string;

  constructor(
    private platform: Platform,
    private translate: TranslateService,
    private modalController: ModalController,
    private guestExportService: GuestExportService,
    private visitorLogoService: VisitorLogoService,
    private functionService: FunctionService,
    private popupService: PopupService,
  ) { }

  ngOnInit() {}

  ngOnDestroy(): void {
      
  }

  ionViewWillEnter() {
    this.topTxt = '';
    this.bottomTxt = '';
    this.config = this.getDefaultConfig();
    this.logoWidth = this.config.width * 0.3;
    this.logoUrl = this.getLogo();
  }

  reset() {
    this.showTxt = false;
    this.topTxt = '';
    this.bottomTxt = '';
  }

  async dismissModal() {
    if (this.modalController) {
      const modal = await this.modalController.getTop();
      if (modal) { this.modalController.dismiss(); }
    }
  }

  getDefaultConfig(): Options {
    return {
      width: 150,
      height: 150,
      type: 'canvas',
      margin: 5,
      qrOptions: {
        typeNumber: 0,
        mode: 'Byte',
        errorCorrectionLevel: 'H'
      },
      imageOptions: {
        hideBackgroundDots: false,
        imageSize: 0.4,
        margin: 0,
        crossOrigin: 'anonymous',
      },
      // dotsOptions: {
      //   color: '#000000',
      //   type: 'dots'
      // },
      // backgroundOptions: {
      // },
      // cornersSquareOptions: {
      //   color: '#000000',
      //   type: 'extra-rounded',
      // },
      // cornersDotOptions: {
      //   color: '#000000',
      //   type: 'dot',
      // }
    };
  }

  async export() {
    await this.popupService.presentLoading(this.translate.instant('LOADING.export'));
    await this.guestExportService.generateQrcodeZip(this.topTxt, this.bottomTxt);
    await this.popupService.dismissLoading();
    // if (!this.platform.is('hybrid') || true) {
      
    // } else {
    //   this.guestExportService.promptOpenWeb();
    // }
  }

  check(type: string) {
    if (this.topTxt === this.bottomTxt) {
      if (type === 'top') {
        this.bottomTxt = '';
      } else if (type === 'bottom') {
        this.topTxt = '';
      }
    }
  }

  checkDisabled() {
    if (this.showTxt) {
      if (!this.topTxt && !this.bottomTxt) {
        return true;
      }
    }
    return false;
  }

  getLogo() {
    let logo = '';
    if (this.visitorLogoService.logo) {
      logo = this.visitorLogoService.logo;
    }
    if (this.functionService.isEmpty(logo) || this.functionService.isUndefined(logo)) {
      logo = './assets/wedding/img/logo/thebigday-logo-round-primary.webp';
    }
    return logo;
  }

}
